var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.transcripts, function(entry, index) {
      return _c("transcript-entry", {
        key: index,
        attrs: {
          entry: entry,
          prerender: true,
          playtime: _vm.playtime,
          "search-query": _vm.searchQuery,
          "ghost-active": _vm.ghostActive,
          "ghost-time": _vm.ghostTime,
          "search-results": _vm.searchResults,
          "chapter-style": _vm.chapterStyle,
          "speaker-style": _vm.speakerStyle
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }